import fetchCors from './fetchcors';
const EventEmitter = require('events');

class QRZ_COM_logbook extends EventEmitter {

  constructor(credentials){
    super();
    try {
          this.key = credentials.key;
    }
    catch {
      this.key = ""
    }
    console.log("welcome to qrz.com logbook");
  }

  htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  postData(data){
    var url = "https://logbook.qrz.com/api"
    data['KEY'] = this.key

    const searchParams = Object.keys(data).sort().map((key)=>{
      return encodeURIComponent(key)+'='+encodeURIComponent(data[key])
    }).join('&')

    return fetchCors(url+"?"+searchParams)
  }

  fetchQsls(){
    console.log("requesting qrzcom");
    this.emit('status', {"qrz.com":"active"})
    var data = {
      "ACTION": "FETCH",
      "OPTION": "ALL"
    }

    return new Promise((resolve, reject) => {
        this.postData(data)
        .then((response)=>{return response.text();})
        .then((text)=>{
          console.log("fetched qrzcom");
          this.emit('status', {"qrz.com":"idle"})
          text = text.split('\n').map((line)=>this.htmlDecode(line))
          resolve(text.join('\n'));
        })
        .catch((err)=>{
          this.emit('status', {"qrz.com":"error"})
          console.log("something went wrong",err);
          reject(err)
        })
    })
  }

  sendEQsl(adif){
    return new Promise((resolve, reject) => {
      console.log("sending to qrzcom...");
      this.emit('status', {"qrz.com":"active"})
      var data = {
        "ACTION": "INSERT",
        "ADIF": adif
      }
      this.postData(data)
        .then((response)=>{return response.text();})
        .then((text)=>{
          console.log(text);
          if (text.includes("RESULT=OK")) {
            this.emit('status', {"qrz.com":"idle"})
            resolve()
          }
          else {
            var rv = /REASON=.*&/g.exec(text);
            console.log(rv[0]);
            this.emit('status', {"qrz.com":"error"})
            reject()
          }
        })
    })
  }
}

export {QRZ_COM_logbook}
